import {useQueryParams} from '@aboutyou/router';
import {CHECKOUT_URL_PARAMS} from '../../../features/Checkout/constants';

export const useAppUrlParams = () => {
  const queryParams = useQueryParams();

  const customerIdParam = queryParams.get(CHECKOUT_URL_PARAMS.customerId);
  const customerId = customerIdParam ? parseInt(customerIdParam, 10) : null;

  const correlationId = queryParams.get(CHECKOUT_URL_PARAMS.correlationId);
  const transactionId = queryParams.get(CHECKOUT_URL_PARAMS.transactionId);
  const paymentProvider = queryParams.get(CHECKOUT_URL_PARAMS.paymentProvider);
  const isExpressFallback = queryParams.get(
    CHECKOUT_URL_PARAMS.expressFallback,
  );

  const entryTimeStamp = queryParams.get(CHECKOUT_URL_PARAMS.entryTimeStamp);
  const clientEntryTimeStamp = queryParams.get(
    CHECKOUT_URL_PARAMS.clientEntryTimeStamp,
  );

  const device = queryParams.get(CHECKOUT_URL_PARAMS.device) as
    | 'ios'
    | 'android'
    | null;
  const hashParam = queryParams.get(CHECKOUT_URL_PARAMS.hash);
  const oAuthHash = hashParam ? decodeURIComponent(hashParam) : null;
  const authToken = queryParams.get(CHECKOUT_URL_PARAMS.authToken);
  const authProvider = queryParams.get(CHECKOUT_URL_PARAMS.authProvider);
  const showSecondaryPriceLabel = queryParams.get(
    CHECKOUT_URL_PARAMS.showSecondaryPriceLabel,
  );

  return {
    device,
    customerId,
    authToken,
    authProvider,
    oAuthHash,
    correlationId,
    entryTimeStamp,
    clientEntryTimeStamp,
    transactionId,
    paymentProvider,
    isExpressFallback,
    showSecondaryPriceLabel: Boolean(showSecondaryPriceLabel),
  };
};
